//------whatsApp audio-player-----//
function getRandomTime() {
    const hours = Math.floor(Math.random() * (22 - 10 + 1)) + 10;
    const minutes = Math.floor(Math.random() * 60);
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    return formattedTime;
}
const audioPlayers = document.querySelectorAll(".audio-player");
const audioElements = new Map();
audioPlayers.forEach((audioPlayer) => {
    const audioUrl = audioPlayer.dataset.url;
    const audio = new Audio(audioUrl);
    audioElements.set(audioPlayer, audio);
    const btnPlayToggle = audioPlayer.querySelector(".btn-play");
    const slider = audioPlayer.querySelector("input[type='range']");

    function setMessageDate() {
        const currentDateTime = getRandomTime();
        audioPlayer.style.setProperty(
            "--player-current-date-time",
            `'${currentDateTime}'`
        );
    }

    function formatTimeToDisplay(seconds) {
        const milliseconds = seconds * 1000;
        return new Date(milliseconds).toISOString().substr(14, 5);
    }

    function handlePlayButton() {
        if (audio.paused) {
            stopAllOtherAudios();
            audio.play();
        } else {
            audio.pause();
        }
    }

    function handleSlider(e) {
        const {
            duration
        } = audio;
        const percent = e.target.value;
        const currentTimeInSeconds = ((percent * duration) / 100).toFixed(2);
        audio.currentTime = currentTimeInSeconds;
    }

    function updateCurrentTimeDisplay(time) {
        audioPlayer.style.setProperty("--player-current-time", `'${time}'`);
    }

    function updateCurrentPercent() {
        const {
            currentTime,
            duration
        } = audio;
        const percentPlayed = (currentTime * 100) / duration;
        slider.value = percentPlayed;
        audioPlayer.style.setProperty(
            "--player-percent-played",
            `${percentPlayed}%`
        );
    }

    function showTimeDuration() {
        const {
            duration
        } = audio;
        const durationDisplay = formatTimeToDisplay(duration);
        updateCurrentTimeDisplay(durationDisplay);
    }

    function stopAllOtherAudios() {
        audioElements.forEach((otherAudio, otherAudioPlayer) => {
            if (otherAudioPlayer !== audioPlayer) {
                otherAudio.pause();
            }
        });
    }

    function start() {
        btnPlayToggle.onclick = handlePlayButton;
        slider.oninput = handleSlider;
        audio.onloadstart = () => {
            setMessageDate();
            audioPlayer.classList.add("loading");
        };
        audio.onplay = () => audioPlayer.classList.add("playing");
        audio.onpause = () => audioPlayer.classList.remove("playing");
        audio.onloadeddata = () => audioPlayer.classList.remove("loading");
        audio.ondurationchange = showTimeDuration;
        audio.onended = () => (audio.currentTime = 0);
        audio.ontimeupdate = () => {
            const {
                currentTime
            } = audio;
            const currentTimeDisplay = formatTimeToDisplay(currentTime);
            updateCurrentTimeDisplay(currentTimeDisplay);
            updateCurrentPercent();
            if (currentTime === 0) {
                showTimeDuration();
            }
        };
    }
    start();
});
//------Zoom on click-image-----//
// const modal = document.getElementsByClassName('idMyModal');
// const img = document.getElementsByClassName('toZoom');
// const modalImg = document.getElementsByClassName('modal-content');
// for ( let i = 0; i < img.length; i++ ) {
//   img[i].onclick = function () {
//     modal[i].style.display = "block";
//     modalImg[i].src = this.src;
//   }
// }

// var span = document.getElementsByClassName("close");
// for ( let i = 0; i < span.length; i++ ) {
//   span[i].onclick = function() {
//     modal[i].style.display = "none";
//   }
// }

$('img.img-loading').each(function() {
    let $img = $(this);

    function removeLoadingEffect() {
        $img.removeClass('img-loading');
    }

    if ($img[0].complete && $img[0].naturalWidth !== 0) {
        removeLoadingEffect();
    } else {
        $img.one('load', removeLoadingEffect).one('error', removeLoadingEffect);
    }
});
